module.exports = __webpack_public_path__ + "static/img/qujian-tips-1.7102686.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qujian-tips-1.jpg
// module id = OvL+
// module chunks = 1